var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowGreyRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 97,
    fill: "none",
    viewBox: "0 0 1440 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F6",
    d: "M-1.287.706L1440.81 96.428H-1.287V.706z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2E2BF",
    d: "M-1.248.401H1439.71v96.027L-1.248.401z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowGreyRectangle);
export default __webpack_public_path__ + "static/media/YellowGreyRectangle.946b61b4c05561e983dd86b20dc8b468.svg";
export { ForwardRef as ReactComponent };